export default __webpack_public_path__ + "static/hpe-c2726267b77ba7e78cbf5c2a18957828.svg";